import { useMemo } from "react";

interface args {
  totalPosts: number;
  currentPage: number;
  postsPerPage: number;
  siblingCount?: number;
}
export const usePagination = ({
  totalPosts,
  currentPage,
  postsPerPage,
  siblingCount = 1,
}: args) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalPosts / postsPerPage);

    // ページ番号を生成する関数
    const range = (start: number, end: number) => {
      let length = end - start + 1;
      return Array.from({ length }, (_, idx) => idx + start);
    };

    // 表示するページ番号の範囲を決定
    const totalPageNumbers = siblingCount + 5;

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount,
    );

    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      let leftItemCount = 3 + 2 * siblingCount;
      let leftRange = range(1, leftItemCount);
      return [...leftRange, "...", totalPageCount];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      let rightItemCount = 3 + 2 * siblingCount;
      let rightRange = range(
        totalPageCount - rightItemCount + 1,
        totalPageCount,
      );
      return [1, "...", ...rightRange];
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      let middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [1, "...", ...middleRange, "...", totalPageCount];
    }
  }, [totalPosts, currentPage, postsPerPage, siblingCount]);

  return {
    paginationRange,
    totalPages: Math.ceil(totalPosts / postsPerPage),
  };
};

export default usePagination;
